import {translate} from "react-i18nify";

import * as formatHelper from "./formatHelper";

export const formatCurrentPrintData = (data) => {
    try {
        let date = new Date();

        let result = {
            ...data,
            packageordercount: "1/" + data.packagecount,
            currdate: formatHelper.formatDate(date),
            currdatetime: formatHelper.formatDateTime(date),
            currtime: formatHelper.formatTime(date)
        };

        if (result["custom_package"] !== undefined) {
            if (Array.isArray(result["custom_package"]) && result["custom_package"].length === 3) {
                result["custom_package"][0] = translate("general.customPackage");
                result["custom_package"][1] = formatHelper.formatDecimal(result["custom_package"][1]);

                result["canname"] = result["packagename"] = result["package"] = result["custom_package"].join(" ");
            } else {
                result["canname"] = result["packagename"] = result["package"] = "";
            }

            delete result["custom_package"];
        }

        return result;
    } catch (e) {
        return {
            ...data,
            packageordercount: "",
            currdate: "",
            currdatetime: "",
            currtime: "",
            canname: "",
            packagename: "",
            package: ""
        };
    }
};
